/**
 * Recursively remove empty (null or undefined) properties from an object.
 *
 * @param {object} object
 * @param {object} options
 * @param {boolean} options.allowNull defaults to false. If true, only undefined properties will be removed.
 */
function removeEmptyProperties(object, options = { allowNull: false }) {
    if (object == null) {
        throw new Error(`Expected object/array, got ${object}`);
    }

    // Arrays need separate handling or they'll cease to be JS arrays
    if (Array.isArray(object)) {
        return object.filter(value => isNotEmpty(value, options)).map(value => recurseIfNecessary(value, options));
    }

    return Object.fromEntries(
        Object.entries(object)
            .filter(([ , value ]) => isNotEmpty(value, options))
            .map(([ key, value ]) => [ key, recurseIfNecessary(value, options) ]),
    );
}

function isNotEmpty(value, { allowNull = false }) {
    return value !== undefined && (allowNull || value !== null);
}

function recurseIfNecessary(value, options) {
    return value != null && typeof value === 'object' && !(value instanceof Date)
        ? removeEmptyProperties(value, options)
        : value;
}

export default removeEmptyProperties;
